/**
 * MOCK FIXTURE DATA - user accounts
 * ---------------------------------
 * Same three demo accounts as `@hp/workbench`'s `mocks/authStore.ts` (one
 * per role), so a demo user can sign in to either app with the same
 * credentials while each app tracks its own session independently. See
 * that file for why credentials live in a parallel map here rather than
 * on `User` itself.
 */
import type { User, UserRole } from "@hp/api-client";

function makeUser(id: string, email: string, name: string, role: UserRole): User {
  return {
    id,
    email,
    name,
    role,
    is_active: true,
    created_at: "2026-01-05T09:00:00Z",
    last_login_at: null,
  };
}

export const DEMO_CREDENTIALS: Array<{ email: string; password: string; role: UserRole }> = [
  { email: "admin@hindustanpower.com", password: "admin123", role: "admin" },
  { email: "reviewer@hindustanpower.com", password: "reviewer123", role: "reviewer" },
  { email: "cfo@hindustanpower.com", password: "executive123", role: "executive" },
];

export const usersStore: User[] = [
  makeUser("user-admin-1", "admin@hindustanpower.com", "Aditi Rao", "admin"),
  makeUser("user-reviewer-1", "reviewer@hindustanpower.com", "Rahul Mehta", "reviewer"),
  makeUser("user-executive-1", "cfo@hindustanpower.com", "Kavita Iyer", "executive"),
];

const passwordsByEmail = new Map<string, string>(
  DEMO_CREDENTIALS.map((account) => [account.email, account.password]),
);

export function findUserByEmail(email: string): User | null {
  return usersStore.find((user) => user.email.toLowerCase() === email.toLowerCase()) ?? null;
}

export function checkMockPassword(email: string, password: string): boolean {
  return passwordsByEmail.get(email.toLowerCase()) === password;
}

export function issueMockToken(user: User): string {
  return `mock-token-${user.id}`;
}

export function resolveMockToken(token: string): User | null {
  const id = token.replace(/^mock-token-/, "");
  return usersStore.find((user) => user.id === id) ?? null;
}
